import type { FavoriteViewFolder } from '@/api/favorites'
import { useTranslation } from 'react-i18next'
import { CHECK_EMOJI_UNIFIED, FavoriteViewEmoji } from '@/components/FavoriteViews/FavoriteViewEmoji'
import { FavoriteViewManagementMenu } from '@/components/FavoriteViews/FavoriteViewManagementMenu'
import './favorite-view-folder-card.scss'

export const ALL_SAVED_VIEWS_ID = 'all-saved-views'

interface FavoriteViewFolderCardProps {
  folder: FavoriteViewFolder
  onSelect: () => void
  onRename?: () => void
  onDelete?: () => void
  isSelected?: boolean
  disabled?: boolean
}

export function FavoriteViewFolderCard({ folder, onSelect, onRename, onDelete, isSelected, disabled }: Readonly<FavoriteViewFolderCardProps>) {
  const { t } = useTranslation()
  const isAllSavedViews = folder.id === ALL_SAVED_VIEWS_ID

  return (
    <li className="favorite-view-folder" data-testid={`favorite-view-folder-item-${folder.id}`}>
      <button
        type="button"
        disabled={disabled}
        className={`favorite-view-folder__button${isSelected ? ' favorite-view-folder__button--selected' : ''}`}
        aria-pressed={isSelected}
        onClick={onSelect}
        data-testid={`favorite-view-folder-${folder.id}`}
      >
        <span className={`favorite-view-folder__preview${isAllSavedViews ? ' favorite-view-folder__preview--all' : ''}`} aria-hidden="true">
          <FavoriteViewEmoji unified={isAllSavedViews ? CHECK_EMOJI_UNIFIED : folder.emoji} />
        </span>
        <span className="favorite-view-folder__content">
          <span className="favorite-view-folder__name">{folder.name}</span>
          <span className="favorite-view-folder__count">
            {t('favorite-views.page.favorites-count', { count: folder.viewCount })}
          </span>
        </span>
      </button>
      {!isAllSavedViews && onRename && onDelete && (
        <FavoriteViewManagementMenu
          accessibleName={t('favorite-views.management.manage-folder', { name: folder.name })}
          dialogType="folder"
          menuId={`favorite-view-folder-menu-${folder.id}`}
          menuTestId={`favorite-view-folder-menu-${folder.id}`}
          onRename={onRename}
          onDelete={onDelete}
          renameTestId={`favorite-views-rename-folder-${folder.id}`}
          deleteTestId={`favorite-views-delete-folder-${folder.id}`}
          triggerTestId={`favorite-view-folder-menu-button-${folder.id}`}
        />
      )}
    </li>
  )
}
